<template>
  <div v-if="compareMode ? casino.visible : casino.visible && !casino.compared" class="card shadow-lg mb-2 border border-dark lift lift-sm">
    <div class="card-body p-0">
      <div class="row d-flex m-0">
        <div class="col-12 col-sm-2 mb-2 p-1 text-center">
          <a :href="casino.link_casino" rel="nofollow sponsored" target="_blank" :title="'Sito casinò ' +  casino.nome">
          <img class="img-fluid border-3" :src="'https://img.casino2k.com/' + casino.logo" />
          </a>
          <div class="icon icon-xl mt-2">
            <img class="img-fluid" src="https://cdn1.casino2k.com/templates/casino2ktemplate/img/adm.svg" />

          </div>
        </div>
        <div class="col-12 col-sm-10 pl-5">
          <div class="row">
            <div class="col-12 p-2">
              <div class="d-flex text-center flex-wrap mt-2">
                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"><span class="dosis-font-700 text-verde font-size-sm">{{ casino.bonus_con_deposito !== 0  ? casino.bonus_con_deposito + "%" : '-'  }}</span>
                 Bonus 1° Dep.</p>
                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"><span class="dosis-font-700 text-verde font-size-sm">{{ casino.bonus_con_deposito_max !== 0 ? casino.bonus_con_deposito_max + ' €' : '-' }}</span>
                  Bonus 1° Dep Max</p>
                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"><span class="dosis-font-700 text-verde font-size-sm">{{ casino.bonus_senza_deposito !== 0 ? casino.bonus_senza_deposito + ' €' : '-' }}</span>
                  Bonus Gratis</p>

                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"><span class="dosis-font-700 text-verde font-size-sm">{{ casino.bonus_free_spins !== 0 ? casino.bonus_free_spins : '-' }}</span>
                  Free spins</p>
                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"><span class="dosis-font-700 text-verde font-size-sm">{{ casino.playthrough !== 0 ? casino.playthrough + 'x' : '-' }}</span>
                  PT</p>
                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"> <span class="dosis-font-700 font-size-sm"><i v-if="casino.live" class="fe fe-check-circle text-verde mr-2"></i>
                    <i v-else class="fe fe-x-circle text-red-600 mr-2"></i></span>
                  Giochi live
                </p>

                <p class="font-size-xs text-black text-left mb-1 pt-1 pb-1 mr-2 border p-1"> <span class="dosis-font-700 font-size-sm"><i v-if="casino.mobile_con_app" class="fe fe-check-circle text-verde mr-2"></i>
                    <i v-else class="fe fe-x-circle text-red-600 mr-2"></i></span>
                  App mobile
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-sm-2 p-2">
              <a class="btn btn-block btn-sm btn-secondary ml-auto mr-1 text-white" rel="nofollow sponsored" target="_blank" :title="'Sito casinò ' +  casino.nome" :href="casino.link_casino">
                <i class="fe fe-link"></i> Vai al sito
              </a>
            </div>
            <div class="col-6 col-sm-2 p-2">
              <a class="btn btn-sm btn-black ml-auto btn-block text-white"  :title="'Recensione casinò ' +  casino.nome" :href="casino.link_recensione" >
                <i class="fe fe-edit-2"></i> Recensione
              </a>
            </div>
             <div class="col-12 col-sm-8 p-2">
              <a v-if="!casino.compared && $store.getters.compare.length < (isMobile() ? 2 :3)" @click="addToCompare" class="btn btn-block btn-sm btn-outline-secondary ml-auto mr-1">
                <i class="fe fe-plus-circle"></i> Aggiungi al confronto
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import store from '../store';
  export default {
    name: 'CasinoResult',
    props: ['casino', 'compareMode'],
    store,
    components: {},
    methods: {
      addToCompare() {
        store.getters.compare.push(this.casino);
        store.commit('setCompare', store.getters.compare);
        store.getters.results.find((e) => e.id == this.casino.id).compared = true;
        store.commit('setResults', store.getters.results);

      },
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      removeToCompare() {
        store.commit(
          'setCompare',
          store.getters.compare.filter((e) => e.id !== this.casino.id)
        );
        store.getters.results.find(
          (e) => e.id == this.casino.id
        ).compared = false;
      },
    },
    mounted() {},
  };
</script>